import { IReport } from '@opengov/reporting-types';
import React, { useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { DialogContentText } from '@mui/material';
import { IReportLocale } from '../../common/locale';
import { DeleteDialog } from '../../../src/components/DeleteDialog/DeleteDialog';
import { useToastContext } from '../../../src/components/Toast/contexts/useToast.context';
import { ToastProps } from '../../../src/components/Toast/Toast';

export interface IReportDeletingModal {
  reportLocaleText: IReportLocale;
  report: IReport;
  onClose(): void;
  onDelete(Report: IReport, navigate: NavigateFunction, toggleToast: (toastProps: ToastProps) => void): void;
}

export const ReportDeletingDialog = (props: IReportDeletingModal) => {
  const { toggleToast } = useToastContext();
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    setIsDeleting(true);
    props.onDelete(props.report, navigate, toggleToast);
  };

  const {
    onClose,
    reportLocaleText: {
      delete: { confirmString },
      reportExplorer: {
        delete: { title, body1, body2, helper }
      }
    }
  } = props;

  return (
    <DeleteDialog
      title={title}
      dataTest="deleteReportDialog"
      isDeleting={isDeleting}
      onClose={onClose}
      onDelete={handleDelete}
      dataTestInput="reportConfirmationInput"
      helperText={helper({ confirm: confirmString })}
      dataTestHeader="reportDeleteDialogTitle"
      dataTestConfirmBtn="delete-report-confirmation-button"
    >
      <>
        <DialogContentText>{body1}</DialogContentText>
        <DialogContentText>{body2}</DialogContentText>
      </>
    </DeleteDialog>
  );
};
